<template>
  <v-container class="pt-1 pb-0" fluid>
    <v-row class="pl-2" justify="center" align="center" no-gutters>
      <v-menu
        v-model="menuDataInicial"
        :close-on-content-click="false"
        :nudge-top="48"
        :nudge-right="10"
        transition="scale-transition"
        max-width="290"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            class="mb-n5 mr-1"
            style="max-width: 125px"
            :value="formatDataInicial"
            append-icon="mdi-calendar"
            label="Data Inicial"
            placeholder=" "
            @click:clear="dataInicial = null"
            v-on="on"
            outlined
            readonly
            dense
          ></v-text-field>
        </template>
        <v-date-picker
          locale="pt-br"
          v-model="dataInicial"
          @change="menuDataInicial = false"
        ></v-date-picker>
      </v-menu>
      <v-menu
        v-model="menuDataFinal"
        :close-on-content-click="false"
        :nudge-top="48"
        :nudge-right="10"
        transition="scale-transition"
        max-width="290"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            class="mb-n5 ml-1"
            style="max-width: 125px"
            :value="formatDataFinal"
            append-icon="mdi-calendar"
            label="Data Final"
            placeholder=" "
            @click:clear="dataFinal = null"
            v-on="on"
            outlined
            readonly
            dense
          ></v-text-field>
        </template>
        <v-date-picker
          locale="pt-br"
          v-model="dataFinal"
          @change="menuDataFinal = false"
        ></v-date-picker>
      </v-menu>
      <v-btn @click="atualizarDados()" class="primary ml-3 mt-n1" style="width: 32px; height: 32px" dark icon>
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </v-row>

    <div v-if="chartData.length && items.length" class="mt-1">
      <v-row style="max-width: 400px; margin: 0 auto" no-gutters>
        <v-select
          :items="[{ text: 'Colunas', value: 'ColumnChart' }, { text: 'Pie (Pizza)', value: 'PieChart' }]"
          item-text="text"
          item-value="value"
          v-model="chartType"
          @change="alterarTipoGrafico"
          label="Formato do Gráfico"
          class="mb-2"
          hide-details
        />
        <v-btn
          @click="dialogLegenda = true"
          color="primary"
          class="mt-4 ml-3"
          small
        >
          Ver Legenda
        </v-btn>
      </v-row>
      <GChart
        :class="chartType === 'PieChart' ? 'ml-n6' : 'ml-n1'"
        :type="chartType"
        style="width: 100vw; height: 40vh"
        :data="chartData"
        :options="chartOptions"
      />
    </div>

    <v-dialog v-model="dialogLegenda">
      <v-card>
        <v-card-title>
          Legenda do Gráfico
        </v-card-title>
        <v-card-text>
          <span v-for="(row, index) in chartData" :key="index">
            <span v-if="index > 0">
              <v-icon :color="row[2]">
                mdi-checkbox-blank-circle
              </v-icon>
              {{ row[0] }}
              <br>
            </span>
          </span>
        </v-card-text>
        <v-divider class="mt-n2"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogLegenda = false" color="error" small>
            <v-icon class="mr-1" style="font-size: 13px !important">
              mdi-close
            </v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row v-if="items.length" class="my-3 mx-n3" no-gutters>
      <table style="width: 100%; border-spacing: 0px" class="text-left">
        <thead style="background-color: #EEEEEE">
        <tr>
          <th>#</th>
          <th>Produto</th>
          <th>Lucro-Bruto</th>
          <th>%</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) of items" :key="index">
          <td class="pl-4">{{ index + 1 }}</td>
          <td class="pl-4">{{ item.grupo }}</td>
          <td class="pl-4">{{ item.lucro | formatCurrency }}</td>
          <td class="pl-2">{{ parseFloat((item.lucro / lucroTotal) * 100).toFixed(2) }}</td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td class="pl-4" colspan="2">
            <b>
              SUBTOTAL
            </b>
          </td>
          <td class="pl-4" colspan="2">
            <b>
              {{ lucroTotal | formatCurrency }}
            </b>
          </td>
        </tr>
        <tr>
          <td class="pl-4" colspan="2">
            <b>
              PERCAS
            </b>
          </td>
          <td class="pl-4" colspan="2">
            <b>
              {{ percas | formatCurrency }}
            </b>
          </td>
        </tr>
        <tr>
          <td class="pl-4" colspan="2">
            <b>
              TOTAL
            </b>
          </td>
          <td class="pl-4" colspan="2">
            <b>
              {{ (lucroTotal - percas) | formatCurrency }}
            </b>
          </td>
        </tr>
        </tfoot>
      </table>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { GChart } from 'vue-google-charts'
import * as api from '@/api/lucratividade'
import moment from 'moment'

export default {
  filters: {
    formatCurrency (number) {
      return number.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    }
  },
  components: {
    GChart
  },
  data () {
    return {
      headers: [
        { text: '#', sortable: false },
        { text: 'Grupo', value: 'grupo', sortable: false },
        { text: 'Lucro', value: 'lucro', sortable: false },
        { text: '%', sortable: false }
      ],
      colors: [
        '#3366CC',
        '#DC3912',
        '#FF9900',
        '#109618',
        '#990099',
        '#0099C6',
        '#f4fc03',
        '#ff45c7',
        '#b3ff70'
      ],
      items: [],
      dataInicial: moment().startOf('month').format('YYYY-MM-DD'),
      dataFinal: moment().endOf('month').format('YYYY-MM-DD'),
      menuDataFinal: false,
      menuDataInicial: false,
      percas: 0,
      lucroTotal: 0,
      chartType: 'ColumnChart',
      chartData: [],
      dialogLegenda: false,
      chartOptions: {
        chart: {
          title: 'Company Performance',
          subtitle: 'Sales, Expenses, and Profit: 2014-2017'
        },
        chartArea: { width: '75%', height: '92%' },
        legend: { position: 'none' },
        bar: { groupWidth: '60%' }
      }
    }
  },
  computed: {
    ...mapGetters('authData', ['loggedInUser']),
    ...mapState({
      confirm: state => state.global.confirm
    }),
    formatDataInicial () {
      return this.dataInicial ? moment(this.dataInicial).format('DD/MM/YYYY') : ''
    },
    formatDataFinal () {
      return this.dataFinal ? moment(this.dataFinal).format('DD/MM/YYYY') : ''
    }
  },
  mounted () {
    this.atualizarDados()
  },
  methods: {
    ...mapMutations('global', ['setLoading']),
    alterarTipoGrafico () {
      // if (this.chartType === 'PieChart') {
      //   this.chartOptions.chartArea.width = '100%'
      //   this.chartOptions.chartArea.height = '100%'
      // } else {
      //   this.chartOptions.chartArea.width = '75%'
      //   this.chartOptions.chartArea.height = '92%'
      // }
    },
    async atualizarDados () {
      this.setLoading(true)
      try {
        const dados = {
          dataInicial: this.dataInicial,
          dataFinal: this.dataFinal
        }
        this.items = await api.buscarDadosGrafico(dados)

        this.percas = this.items.reduce(function (a, b) {
          return b.percas
        }, 0)

        this.lucroTotal = this.items.reduce(function (a, b) {
          return a + b.lucro
        }, 0)
        let index = -1
        const chartData = this.items.map(item => {
          index >= 9 ? index = 0 : index += 1
          return [item.grupo, item.lucro, this.colors[index]]
        })
        chartData.unshift(['Produto', 'Lucro', { role: 'style' }]) // Insere o cabeçalho no começo do array
        this.chartData = chartData
        if (this.items.length) {
          this.$toast.success('Os dados foram atualizados.', 'Sucesso!', { timeout: 2000 })
        } else {
          this.$toast.error('Verifique as datas informadas.', 'Não há dados disponíveis.')
        }
      } catch (error) {
        this.$toast.error(error, 'Ocorreu um Erro!')
      }
      this.setLoading(false)
    }
  }
}
</script>

<style scoped>
</style>
